@if (itemDetails() && isModal){
    <modal-navbar-details [title]="itemDetails().name || ''" />
}

@if (itemDetails()){
    <main 
      class="item-details"
      [attr.data-from-planner]="fromBottomSheet()"
    >
        @if (itemDetails().name) {
          <header-details 
              [name]="itemDetails().name" 
              [type]="itemDetails().type" 
              [id]="itemDetails().id" 
              [duration]="itemDetails()?.duration"
              [accessibilityList]="itemDetails()?.accessibility"
              [fromBottomSheet]="fromBottomSheet()"
          />
        }
            
        @if (!isMultimedia() && defaultFileImgName) { 
          <!--img send by state router from generic card component-->
          <div 
            class="hero__no-multimedia-img-wrapper"
            [ngClass]="{'modalSize': fromBottomSheet()}"
          >
           <img 
              draggable="false" 
              [src]="defaultFileImgName" 
              class="hero__no-multimedia-img"
            >
          </div>
        } @else if(!isMultimedia() && getDefaultImgFromBottomSheetData()) {
          <!--img send by state router from generic card component-->
          <div 
            class="hero__no-multimedia-img-wrapper"
            [ngClass]="{'modalSize': fromBottomSheet()}"
          >
          <img 
              draggable="false" 
              [src]="getDefaultImgFromBottomSheetData()" 
              class="hero__no-multimedia-img"
            >
          </div>
        } @else {
          <details-hero 
            [items]="itemDetails().multimedia" 
            [itemType]="itemDetails().type"
            [categoryNameSlug]="categoryNameSlug"
            [defaultFileImgName]="defaultFileImgName"
            [isBottomSheet]="fromBottomSheet()" 
          />
        } 
        
        @if (itemDetails().action_buttons || itemDetails().photo_360) {
          <details-action-buttons 
            [actionButtons]="itemDetails().action_buttons" 
            [image360]="itemDetails().photo_360" 
            [speaker]="itemDetails().speaker" 
            [itemId]="itemDetails().id"
            [fromBottomSheet]="fromBottomSheet()"
          />
        }

        <div class="details-content">
          <div 
            class="details__grid-content"
            [class.fromBottomSheet]="fromBottomSheet()"
          >
            <div class="grid-content__left">
              @if (itemDetails().description) {
                <details-description 
                  [description]="itemDetails().description" 
                  [fromBottomSheet]="fromBottomSheet()"
                />
              }
              
              @if (itemDetails().extra_fields) {
                <details-extra-fields 
                  [extraFields]="itemDetails().extra_fields" 
                  [fromBottomSheet]="fromBottomSheet()"
                />
              }
            </div>
            
            <div class="grid-content__right">
              @if (itemDetails().location?.address) {
                <details-location 
                  [location]="itemDetails().location" 
                  [fromBottomSheet]="fromBottomSheet()"
                />
              }
              
              @if (itemDetails().dateRange?.start && itemDetails().dateRange?.end) {
                <details-date-range 
                  [start]="itemDetails().dateRange.start" 
                  [end]="itemDetails().dateRange.end" 
                  [fromBottomSheet]="fromBottomSheet()"
                />
              }

              @if (itemDetails().schedule) {
                <details-schedule 
                  [schedule]="itemDetails().schedule" 
                  [fromBottomSheet]="fromBottomSheet()"
                />
              }
              
              @if (itemDetails().price) {
                <details-price 
                  [price]="itemDetails().price" 
                  [fromBottomSheet]="fromBottomSheet()"
                />
              }
            </div>
          </div>
          
          @if (itemDetails().offers?.length > 0) {
            <details-offers 
              [offers]="itemDetails().offers" 
              [fromBottomSheet]="fromBottomSheet()"
            />
          }

          @if (itemDetails().tags) {
            <app-tags 
              [tags]="itemDetails().tags" 
              [class.fromBottomSheet]="fromBottomSheet()"
            />  
          }
        </div>
  </main>
}

<!---- ACTIONS BUTTONS MODAL --------------------------------------------------------------------------------------------->

@if(isModal && addItem){
    <div class="modal-button-container">
      <button (click)="acceptItem()">{{'Añadir a la ruta' | translate}}</button>
    </div>
}
  
@if(isModal && removeItem){
    <div class="modal-button-container">
      <button class="remove-item" (click)="acceptItem()">{{'Eliminar de la ruta' | translate}}</button>
    </div>
}

<!---- GRAB-HANDLE BOTTOM SHEET FROM PLANNER CUSTOM-ROUTE-MOBILE AND CUSTOM-ROUTE-DESKTOP --------------------------------------------------------------------------------------------->
@if(fromBottomSheet()) {
  <app-drag-handle />
}

<!---- ACTIONS BUTTONS BOTTOM SHEET FROM PLANNER CUSTOM-ROUTE-MOBILE --------------------------------------------------------------------------------------------->
@if(fromBottomSheet()) {
  <ci-icon-button
    [class.bottom-sheet-mobile__close-button]="fromPointPlannerCustomRouteMobile()"
    [class.bottom-sheet-desktop__close-button]="fromPointPlannerCustomRouteDesktop()"
    type="tonal" 
    name="close"
    (click)="closeBottomSheet()"
  ></ci-icon-button>
}

